import { render, staticRenderFns } from "./MenuPrincipalDropdown.vue?vue&type=template&id=362aa2c4&scoped=true&"
import script from "./MenuPrincipalDropdown.vue?vue&type=script&lang=js&"
export * from "./MenuPrincipalDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362aa2c4",
  null
  
)

export default component.exports